// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__odF+1","outer":"ProgressBar_outer__nRGgI","inner":"ProgressBar_inner__vnRRk","trailingDot":"ProgressBar_trailingDot__eAj61"};